import { useScreenSize } from '@ltvco/refresh-lib/utils';
import React, { createContext, useContext, ReactNode } from 'react';

import { viewTypes } from '../SearchFilter/interfaces';

interface SearchPersonResultsContextType {
  currentView: string;
  // eslint-disable-next-line no-unused-vars
  setCurrentView: (view: string) => void;
  isOnMobileCardInDesktopVariation: boolean;
  meetMobileCardInDesktopCriteria?: boolean;
  isChatPage?: boolean;
  // eslint-disable-next-line no-unused-vars
  handlePersonReport?: (bvid: string) => void;
  // eslint-disable-next-line no-unused-vars
  handleObituaryReport?: (permalink: string) => void;
  handleContactReport?: (permalink: string) => void;
  handleAncestorReport?: (permalink: string) => void;
}

const SearchPersonResultsContext = createContext<
  SearchPersonResultsContextType | undefined
>(undefined);

export const useSearchPersonResultsContext = () => {
  const context = useContext(SearchPersonResultsContext);
  if (!context) {
    throw new Error(
      'useSearchPersonContext must be used within a SearchPersonProvider'
    );
  }
  return context;
};
interface SearchPersonResultsProviderProps {
  children: ReactNode;
  value: SearchPersonResultsContextType;
}

export const SearchPersonResultsProvider: React.FC<
  SearchPersonResultsProviderProps
> = ({ children, value }) => {
  const { isMobile } = useScreenSize();
  const { currentView, isOnMobileCardInDesktopVariation, isChatPage } = value;
  const meetMobileCardInDesktopCriteria =
    (isOnMobileCardInDesktopVariation &&
      !isMobile &&
      currentView === viewTypes.GRID) ||
    isChatPage;

  return (
    <SearchPersonResultsContext.Provider
      value={{ ...value, meetMobileCardInDesktopCriteria }}
    >
      {children}
    </SearchPersonResultsContext.Provider>
  );
};
